import { getReturnableQuantity } from "../lib/returnable-items.lib";
import type { OrderLineItem } from "../types";
import { useReturnRequests } from "./use-return-requests";

/**
 * How many units of `lineItem` the customer may still put in a return, using
 * the same rule as the article list so the quantity picker can never offer more
 * than what `filterReturnableItems` let through.
 */
export function useReturnableQuantity(
  lineItem: OrderLineItem | undefined,
  { orderId, shopSlug }: { orderId: string; shopSlug: string },
): number {
  const { data } = useReturnRequests({ orderId, shopSlug });

  if (!lineItem) return 0;

  return getReturnableQuantity(lineItem, data?.returnRequests ?? []);
}
